import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import AccionaButton from '../../../components/AccionaButton';
import { useIntl } from 'react-intl';
import ProjectCard from './components/ProjectCard';

const { utils } = styles;

const Projects = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const projects = useSelector(({ projects }) => projects.list);
  const { me } = useSelector(({ auth }) => auth);
  const isAdmin = me?.role === 'ADMIN';

  return (
    <>
      <div className="row">
        <div className={`col-sm-12 ${utils}`}>
          {isAdmin && (
            <AccionaButton
              msg={intl.formatMessage({ id: 'projects.create.new.button' })}
              classIcon="fas fa-plus"
              onClick={() => {
                navigate('create');
              }}
            />
          )}
        </div>
      </div>
      <div className="row">
        {projects.map((project) => (
          <ProjectCard
            project={project}
            key={project.id_project}
            allowEditing={isAdmin}
          />
        ))}
      </div>
    </>
  );
};

export default Projects;
